import type React from 'react';

import { withI18nPlaceholders } from '@change-corgi/core-react/i18n';

import I18N_PLACEHOLDERS from '#config/i18n/placeholders/videoFirstHero/video-first-hero.yml';

import { VideoFirstHeroDesktop } from './components/VideoFirstHeroDesktop';
import { VideoFirstHeroMobile } from './components/VideoFirstHeroMobile';
import { useVideoFirstHero } from './hooks/useVideoFirstHero';
import type { VideoFirstViewport } from './hooks/useVideoFirstHero';
import type { VideoFirstHeroStatus } from './hooks/useVideoFirstHeroStatus';

export { useVideoFirstHeroStatus } from './hooks/useVideoFirstHeroStatus';
export type { VideoFirstHeroStatus } from './hooks/useVideoFirstHeroStatus';

const VideoFirstHeroComponent: React.FC<Props> = ({ fallback, sourceUrl, status, viewport }): React.ReactNode => {
	const {
		data: { coverUrl, creatorName, playerUrl, signatureCount, signatureGoal, title, titleDataQa },
	} = useVideoFirstHero(sourceUrl, viewport);

	if (status === 'fallback' || !playerUrl) return fallback;

	const activePlayerUrl = status === 'rendered' ? playerUrl : undefined;

	if (viewport === 'desktop') {
		return (
			<VideoFirstHeroDesktop
				coverUrl={coverUrl}
				creatorName={creatorName}
				playerUrl={activePlayerUrl}
				title={title}
				titleDataQa={titleDataQa}
			/>
		);
	}

	return (
		<VideoFirstHeroMobile
			coverUrl={coverUrl}
			creatorName={creatorName}
			playerUrl={activePlayerUrl}
			signatureCount={signatureCount}
			signatureGoal={signatureGoal}
			title={title}
			titleDataQa={titleDataQa}
		/>
	);
};

export const VideoFirstHero = withI18nPlaceholders(I18N_PLACEHOLDERS, VideoFirstHeroComponent);

type Props = {
	fallback: React.ReactNode;
	sourceUrl: string;
	status: VideoFirstHeroStatus;
	viewport: VideoFirstViewport;
};
